module.exports = __webpack_public_path__ + "img/avatar.121e70ad.png";